import AddToFavorites from '@app/Likes/Add'
import AddToFavoritesGeneral from '@app/Likes/AddGeneral'
import FavoritePreview from '@app/Likes/Preview'
import LikesView from '@app/Likes/View'

export default function install(Vue) {
  Vue.component(AddToFavorites.name, AddToFavorites)
  Vue.component(AddToFavoritesGeneral.name, AddToFavoritesGeneral)
  Vue.component(FavoritePreview.name, FavoritePreview)
  Vue.component(LikesView.name, LikesView)
}
